export const RegexEnum = {
  textFeild: '^[a-zA-Z]*$',
  email: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$',
  multipleEmail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  mobile:
    '^(?:(?:\\+?1[-.\\s]?)?(?:\\(?\\d{3}\\)?)[-.\\s]?\\d{3}[-.\\s]?\\d{4}|(?:\\+?91|0)?[-.\\s]?(?:[6-9]\\d{2})[-.\\s]?\\d{3}[-.\\s]?\\d{4})$',
  httpsUrl:
    /^(https?:\/\/)(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(\/[^\s]*)?(\?[^\s]*)?$/,
  url: '^(https?:\\/\\/)?([\\w-]+(\\.[\\w-]+)+)(:[0-9]+)?(\\/[^\\s]*)?$',
  urlWithoutProtocol: '^([\\da-z.-]+)\\.([a-z.]{2,6})(/[\\w./-]*)*(\\?.*)?$',
  textField: '^[a-zA-Z]*$',
  textField_Exclude_Spaces: /^(\s+\S+\s*)*(?!\s).*$/,
  integerOnly: /^[0-9]+$/,
  textFieldIncludingSpace: '^[a-zA-Z]([a-zA-Z ]*)?$',
  textFieldWithoutSpace: '^[a-zA-Z]+$',
  textFieldSpecialCharNoSpace: '^[^\\n ]*$',
  dateDDMMYYYY:
    '^(0?[1-9]|[12][0-9]|3[01])[-/](0?[1-9]|1[012])[-/]((?:19|20|21)[0-9][0-9])$',
  dateMMDDYYYY:
    '^(0?[1-9]|1[012])[-/](0?[1-9]|[12][0-9]|3[01])[-/]((?:19|20|21)[0-9][0-9])$',
  dateYYYYMMDD:
    '^((?:19|20|21)[0-9][0-9])[-/](0?[1-9]|1[012])[-/](0?[1-9]|[12][0-9]|3[01])$',
  htmlTagsFinding: /<[^>]*>/g,
  hexColor: /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/,
  digit: /^[0-9]*$/,
  numeric: '^[0-9]*.?[0-9]+$',
  instagramHandle: /^(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9._]{1,30}$/,
  hashtag: '^(#[a-zA-Z0-9_]+)(\\s*,?\\s*#[a-zA-Z0-9_]+)*$',
  facebookHandle: /^[A-Za-z]+(?:[ .'-][A-Za-z]+)*$/,
  alphanumericWithSpace: /^[a-zA-Z0-9 ]+$/, // Letters, numbers, and spaces
};
